import styled from "styled-components";

export const StyledPaymentScreen = styled.div`
  display: flex;
  justify-content: center;
  //align-items: center;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  padding: 40px;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  gap: 6px;
  position: relative;
  box-sizing: border-box;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 5% 30% 10% 30%;
  }
  img {
    height: 300px;
  }
  h1 {
    margin-top: 0;
    text-align: center;
    margin-bottom: 0;
  }
  p {
    text-align: center;
    line-height: 27px;
  }
`;
